/// <reference path="../../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class StartProcessActionWorkflowBlock extends SingleOutputWorkflowBlock {

        private width: number;
        private height: number;
        private xPadding: number;
        private yPadding: number;
        private attributes: any;

        public startProcessActionId: string;
        public startProcessActionDto: Wars.Domain.Model.Dtos.Workflow.StartProcessActionDto;
        public standardLabel: Snap.Element;
        
        constructor(id: string, label: string, initialBlock?: boolean) {
            super(id, Wars.Domain.Model.Codes.Enums.BlockType.StartProcessAction, label);

            this.svgWidth = 100;
            this.svgHeight = 40;
            
            this.svgScale = 1;
            this.svgToolbarScale = 0.75;

            this.width = this.svgWidth * this.svgScale;
            this.height = this.svgHeight * this.svgScale;

            this.xPadding = (this.blockWidth - this.width ) / 2;
            this.yPadding = (this.blockHeight - this.height) / 2;

            this.attributes = { id: this.id, class: "start-process-action-workflow-block", "data-class": "workflowBlock", "data-id": "startProcessAction" };
            this.isInitialBlock = initialBlock && initialBlock === true;
        }

        public getBottomPadding(): number {
            return this.yPadding;
        }

        public getTopPadding(): number {
            return this.yPadding;
        }

        public getLeftPadding(): number {
            return this.xPadding;
        }

        public getRightPadding(): number {
            return this.xPadding;
        }

        public getMyCenterPoint(gridCoordinate: models.Coordinate): Coordinate {
            var xOffset = (gridCoordinate.x * this.blockWidth);
            var yOffset = (gridCoordinate.y * this.blockHeight);
            return new Coordinate(this.blockWidth / 2 + xOffset, this.blockHeight / 2 + yOffset);
        }

        public draw(paper: Snap.Paper, coordinate: models.Coordinate): Snap.Element {
            var xOffset = (coordinate.x * this.blockWidth) + this.xPadding;
            var yOffset = (coordinate.y * this.blockHeight) + this.yPadding;

            var entireBlock = this.drawEntireBlock(paper, coordinate);
            var centerPoint = this.getMyCenterPoint(coordinate);
            this.svgElement = paper.rect(xOffset, yOffset, this.width, this.height, 20, 20);
            this.svgElement.attr(this.attributes);

            var label = this.label ? this.label : models.WorkflowBlockManager.getWorkflowBlockNameByType(this.type);
            this.standardLabel = paper.text(centerPoint.x, centerPoint.y + 5, label);
            this.standardLabel.attr({ class: "text" });

            this.drawOptions(paper, coordinate);

            var stateGroup = paper.group(entireBlock, this.svgElement, this.standardLabel, this.deleteImageElement, this.settingsImageElement);
            return stateGroup;
        }

        public drawForToolbar(paper: Snap.Paper): Snap.Element {
            this.svgElement = paper.rect(2, 20, this.width, this.height, 20, 20);
            this.svgElement.attr(this.attributes);
            
            var text = paper.text(this.width/2, this.height/2 + 25, this.label);
            text.attr({ class: "text" });

            var stateGroup = paper.group(this.svgElement, text);
            return stateGroup;
        }

        public getDeleteCoordinate(coordinate: models.Coordinate): Coordinate {
            var x = (coordinate.x * this.blockWidth) + this.xPadding + this.width - this.getIconWidth();
            var y = (coordinate.y * this.blockHeight) + this.yPadding - this.getIconWidth() / 2;
            return new Coordinate(x, y);
        }

        public getSettingsCoordinate(coordinate: models.Coordinate): Coordinate {
            var x = (coordinate.x * this.blockWidth) + this.xPadding;
            var y = (coordinate.y * this.blockHeight) + this.yPadding - this.getIconWidth() / 2;
            return new Coordinate(x, y);
        }

        public populateDto(dto: Wars.Domain.Model.Dtos.Workflow.StartProcessActionDto) {
            this.startProcessActionDto = dto;
        }

        public updateDrawingBasedOnLabelLengths(): void {
            this.trimTextToSize(this.standardLabel, this.width - 10);
        }
    }
}
